module.exports = __webpack_public_path__ + "static/img/accessData.501faa3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/accessData.jpg
// module id = MA7u
// module chunks = 1 3 4 5 6 7